/**
 *
 * Qlist
 *
 */

import { mapState, mapGetters, mapActions } from 'vuex';

import TrackerButton from '@/components/TrackerButton.vue';
//import SharedHeader from '@/components/SharedHeader.vue';
import Footer from '@/components/Footer.vue';
import WayFindBar from '@/components/WayFindBar.vue';
import Aside from '@/components/Aside.vue';
//import TabBar from '@/components/TabBar.vue';
import Spinner from '@/components/Spinner.vue';
import PzButton from '@/components/PzButton.vue';
import QaQtypeNav from '@/views/QA/QuestionList/components/QaQtypeNav.vue';
import QaQuestionFilter from '@/views/QA/QuestionList/components/QaQuestionFilter.vue';
import QaQuestionList from '@/views/QA/QuestionList/components/QaQuestionList.vue';
import QaSearchForm from '@/views/QA/QuestionList/components/QaSearchForm.vue';
import QaSearchList from '@/views/QA/QuestionList/components/QaSearchList.vue';
import QaAskModal from '@/views/QA/QuestionList/components/QaAskModal.vue';

import { PageNoMixin } from '@/scripts/QA/QuestionList/mixins/PageNoMixin';

import { LOGIN_PAGE, QA_QUESTION_LIST_PAGE } from '@/constants/routes';
import { LOADING_MESSAGE } from '@/scripts/QA/QuestionList/QuestionList.constants';

const MakeUrlParamsMixin = {
  name: 'MakeUrlParamsMixin',

  data: () => {
    return {
      urlParams: {},
      strUrlParams: '',
    };
  },

  methods: {
    makeOneUrlParam(k) {
      const v = this.urlParams[k] ? this.urlParams[k] : this.$route.query[k];
      if (v) {
        this.strUrlParams += !this.strUrlParams ? '?' : '&';
        this.strUrlParams += `${k}=${encodeURIComponent(v)}`;
      }
    },

    gotoUrlParams() {
      this.$router.push(QA_QUESTION_LIST_PAGE + this.strUrlParams);
    },
  },
};

// PageNoMixin, MakeUrlParamsMixin
const QaQuestionListMixin = {
  name: 'QaQuestionListMixin',

  components: {
    QaQtypeNav,
    QaQuestionFilter,
    QaQuestionList,
  },

  computed: {
    ...mapGetters({
      mg_userInfo: 'userInfo',
    }),

    c_isMyQaPage() {
      return (
        'myquestion' === this.$route.query.qType ||
        'myanswer' === this.$route.query.qType ||
        'myfollows' === this.$route.query.qType
      );
    },

    c_isLogin() {
      return Boolean(this.mg_userInfo.studentId);
    },
  },

  methods: {
    ...mapActions('QA/QuestionList', {
      ma_getQaQuestionTags: 'getQaQuestionTags',
      ma_getPublicQaQuestionList: 'getPublicQaQuestionList',
      ma_getQaQuestionList: 'getQaQuestionList',
    }),

    makeQuestionUrlParamsAndGo(urlParams) {
      this.urlParams = urlParams;
      this.makeOneUrlParam('qType');
      if (0 !== this.urlParams.courseTagId) {
        this.makeOneUrlParam('courseTagId');
        if (0 !== this.urlParams.bookTagId) {
          this.makeOneUrlParam('bookTagId');
        }
      }
      if (0 !== this.urlParams.pageNo) {
        this.makeOneUrlParam('pageNo');
      }
      window.sessionStorage.setItem('back_url', encodeURIComponent(QA_QUESTION_LIST_PAGE));
      this.gotoUrlParams();
    },

    handlePageChange(pageNo) {
      this.makeQuestionUrlParamsAndGo({
        pageNo,
      });
    },

    getQaQuestionList() {
      const getQaQuestionList = this.c_isMyQaPage
        ? this.ma_getQaQuestionList
        : this.ma_getPublicQaQuestionList;
      getQaQuestionList({
        qType: this.$route.query.qType,
        courseTagId: this.$route.query.courseTagId,
        bookTagId: this.$route.query.bookTagId,
        pageNo: this.c_pageNo,
      });
    },
  },

  created() {
    if (!this.$route.query.queryString) {
      if (this.c_isMyQaPage && !this.c_isLogin) {
        this.$router.push(`${LOGIN_PAGE}?login_redirect_uri=${this.$route.fullPath}`);
        return;
      }
      this.ma_getQaQuestionTags();
      this.getQaQuestionList();
    }
  },
};

// PageNoMixin, MakeUrlParamsMixin
const QaSearchListMixin = {
  name: 'QaSearchListMixin',

  components: {
    QaSearchForm,
    QaSearchList,
  },

  methods: {
    ...mapActions('QA/QuestionList', {
      ma_getQaSearchList: 'getQaSearchList',
    }),

    makeSearchUrlParamsAndGo(urlParams) {
      this.urlParams = urlParams;
      if (this.urlParams.queryString) {
        this.makeOneUrlParam('queryString');
        if (0 !== this.urlParams.pageNo) {
          this.makeOneUrlParam('pageNo');
        }
      }
      this.gotoUrlParams();
    },

    handleSearchPageChange(pageNo) {
      this.makeSearchUrlParamsAndGo({
        queryString: this.$route.query.queryString,
        pageNo,
      });
    },

    getQaSearchList() {
      this.ma_getQaSearchList({
        queryString: this.$route.query.queryString,
        pageIndex: this.c_pageNo - 1,
      });
    },
  },

  created() {
    if (this.$route.query.queryString) {
      this.getQaSearchList();
    }
  },
};

// PageNoMixin, MakeUrlParamsMixin, QaQuestionListMixin
const QaAskMixin = {
  name: 'QaAskMixin',

  components: {
    QaAskModal,
  },

  methods: {
    showQaAskModal() {
      this.$refs.QaAskModal.openQA();
    },

    handleQaAskPosted() {
      if (!this.$route.query.queryString && 1 === this.c_pageNo) {
        this.getQaQuestionList();
      }
    },
  },
};

export default {
  name: 'QuestionList',

  mixins: [
    //
    PageNoMixin,
    MakeUrlParamsMixin,
    QaQuestionListMixin,
    QaSearchListMixin,
    QaAskMixin,
  ],

  components: {
    //SharedHeader,
    Footer,
    //TabBar,
    WayFindBar,
    Aside,
    Spinner,
    PzButton,
    TrackerButton,
  },

  data: () => {
    return {
      loadingMessage: LOADING_MESSAGE,
    };
  },

  computed: {
    ...mapState('QA/QuestionList', {
      ms_isRequest: 'isRequest',
    }),
  },
};
